import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuantumComputingRoutingModule } from './quantum-computing-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    QuantumComputingRoutingModule
  ]
})
export class QuantumComputingModule { }
